<template>
  <dialog
    ref="dialog"
    class="VisionModal"
    :class="{
      'VisionModal--with-sticky-footer': $slots.stickyFooter
    }"
    @close="emit('close')"
    @click="handleOutsideClick"
  >
    <div
      v-if="!hideCloseButton"
      class="VisionModal__header"
    >
      <VisionIconButton
        icon="cross"
        size="x-small"
        class="VisionModal__close"
        @click.stop="emit('close')"
      />
    </div>
    <div class="VisionModal__body">
      <slot />
    </div>
    <div
      v-if="$slots.stickyFooter"
      class="VisionModal__sticky-footer"
    >
      <slot name="stickyFooter" />
    </div>
  </dialog>
</template>

<script setup>
import VisionIconButton from '../VisionIconButton/VisionIconButton.vue'
import { onMounted, watch, ref } from 'vue'

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  hideCloseButton: {
    type: Boolean,
    default: false
  },
  closeOnOutsideClick: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['close'])

const dialog = ref()

onMounted(() => {
  if (props.open) {
    dialog.value.showModal()
  }
})

watch(
  () => props.open,
  (newValue) => {
    if (newValue) {
      dialog.value.showModal()
    } else {
      dialog.value.close()
    }
  }
)

function handleOutsideClick(e) {
  if (!dialog.value) return
  if (!props.closeOnOutsideClick) return

  const dialogDimensions = dialog.value.getBoundingClientRect()

  if (
    e.clientX < dialogDimensions.left ||
    e.clientX > dialogDimensions.right ||
    e.clientY < dialogDimensions.top ||
    e.clientY > dialogDimensions.bottom
  ) {
    dialog.value.close()
  }
}
</script>

<style lang="postcss" scoped>
.VisionModal {
  --vision-modal-height: fit-content;
  --vision-modal-max-height: 36rem;
  --vision-modal-max-width: 36rem;


  max-width: 95dvw;
  max-height: 90dvh;
  height: var(--vision-modal-height, fit-content);

  @apply rounded-md w-full;

  @screen md {
    max-width: var(--vision-modal-max-width);
    max-height: var(--vision-modal-max-height);
  }

  &::backdrop {
    @apply bg-off-black opacity-80 backdrop-blur-[2px];
  }
}

.VisionModal__header {
  @apply flex w-full absolute top-0 z-11;
}

.VisionModal__close {
  @apply mt-2 mr-2 ml-auto mb-2;
}

.VisionModal__body {
  @apply overflow-auto;
}

/**

Modifiers

--with-sticky-footer: fixed section at the bottom of the modal

*/

/**
Modifiers
 */

.VisionModal--with-sticky-footer {
  --sticky-footer-height: 4.5rem;

  .VisionModal__body {
    @apply mb-[var(--sticky-footer-height)] h-[calc(100%_-_var(--sticky-footer-height))] overflow-y-auto;
  }

  .VisionModal__sticky-footer {
    @apply w-full z-11 sticky bottom-0 bg-white border-t border-grey-light h-[var(--sticky-footer-height)] rounded-b-md;
  }
}
</style>
